import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'

export const useRegion = () => {
  const [region, setRegion] = useState(false)
  const { deleteNewRegion, getNewRegion } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Region', 'REGION', 'GET_ALL_REGION_BY_COMPANY')
  const {
    REGION: { GET_ALL_REGION_BY_COMPANY, ADD_REGION, EDIT_REGION, GET_REGION, DELETE_MANY_REGION },
  } = API_URL

  const getAllRegion = async (dto = {}) => {
    GET_ALL(GET_ALL_REGION_BY_COMPANY, setPaginate, getNewRegion, dto)
  }

  const addRegion = (dto) => {
    ADD(ADD_REGION, dto)
  }

  const updateRegion = (dto) => {
    UPDATE(EDIT_REGION, dto)
  }

  const getRegion = (dto) => {
    GET_SINGLE_DATA(GET_REGION, setRegion, dto)
  }

  const deleteManyRegion = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_REGION, dto, 'regionId', setSelected, deleteNewRegion, 'GET_ALL_REGION_BY_COMPANY')
  }

  return {
    addRegion,
    getAllRegion,
    getRegion,
    region,
    updateRegion,
    deleteManyRegion,
    loading,
    paginate,
  }
}
